import { useEffect, useState } from 'react';

// Polls the Cortex XSOAR (dry-run) incident list for the EdgeNotary Activity
// panel's CORTEX tab, scoped to the selected site (edge node). With no site
// selected it returns every site's incidents, as before.
export const cortexEventsUrl = (base, edgeNodeId) =>
  edgeNodeId
    ? `${base}/integrations/cortex/events?edge_node_id=${encodeURIComponent(edgeNodeId)}`
    : `${base}/integrations/cortex/events`;

// Belt and braces: keep only the selected site's incidents even if a server
// that predates the edge_node_id filter returns the mixed list.
export const filterCortexEvents = (events, edgeNodeId) =>
  edgeNodeId ? (events || []).filter(ev => ev.edge_node === edgeNodeId) : (events || []);

export default function useCortexEvents(edgeNodeId, { intervalMs = 5000 } = {}) {
  const [cortexEvents, setCortexEvents] = useState([]);
  useEffect(() => {
    const base = process.env.REACT_APP_API_URL || 'http://localhost:8000';
    let cancelled = false;
    setCortexEvents([]);
    const fetchCortex = () =>
      fetch(cortexEventsUrl(base, edgeNodeId), { credentials: 'include' })
        .then(r => r.json())
        .then(d => { if (!cancelled) setCortexEvents(filterCortexEvents(d.events, edgeNodeId)); })
        .catch(() => {});
    fetchCortex();
    const t = setInterval(fetchCortex, intervalMs);
    return () => { cancelled = true; clearInterval(t); };
  }, [edgeNodeId, intervalMs]);
  return cortexEvents;
}
